import Vue from 'vue';
import KNB from '@dp/knb';
import HornLite from '@mtfe/horn-sdk/dist/web-lite';
import dayjs from 'dayjs';
import Dialog from '@/util/dialog';
import { priceFormat, formatAmount, formatRatio } from '@/util/filter';
import App from './App';
import router from './router';
import store from './store';
import ErrorPlugin from './errorPlugin';
import './component';
import './componentpc';
import { BID, CID } from './constants/statistics';
import URL from './util/url';
import {
  setTags, setExtraData, setMetric, METRICS,
} from './util/owl';
import config from '@/config';

// css配置
import '@ss/mtd-vue/lib/theme2/index.css';
import '@/assets/css/base.scss';
import { getEnvDesc } from './util/knb';

HornLite.init({}, { isDev: config.env !== 'production' });
setTags('env', getEnvDesc());
setExtraData(new Date().getTime());
setMetric(METRICS.ENTER_PAGE_HOST_ENV);
// 引入统计常量
Vue.prototype.$BID = BID;
Vue.prototype.$CID = CID;
// 引入客户端桥
Vue.prototype.KNB = KNB;
// 引入对话框
Vue.prototype.$dialog = Dialog;
// 是不是微信小程序环境
Vue.prototype.$isWXApplet = URL.isWXApplet;
// horn
Vue.prototype.$horn = HornLite;

Vue.prototype.$dayjs = dayjs;

Vue.config.productionTip = false;
Vue.filter('priceFormat', priceFormat);
Vue.filter('formatAmount', formatAmount);
Vue.filter('formatRatio', formatRatio);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

Vue.use(ErrorPlugin);
